module.exports = __webpack_public_path__ + "media/images/common/my_menu_edit-d365f5d377d920aa3b1981b02cb2fa44.png";